import React from 'react';

const LevelsSection = () => {
  const levels = [
    { emoji: '🌱', name: 'Financial Seedling', requirement: 'Join Findell' },
    { emoji: '🌿', name: 'Budget Builder', requirement: 'Stay under budget 2 weeks' },
    { emoji: '💰', name: 'Savings Starter', requirement: 'Save your first $100' },
    { emoji: '📈', name: 'Debt Destroyer', requirement: '3 on-time debt payments' },
    { emoji: '🏆', name: 'Emergency Fund Champion', requirement: '$1,000 saved' },
    { emoji: '💎', name: 'Investment Initiator', requirement: 'Complete Investing 101' },
    { emoji: '🚀', name: 'Wealth Builder', requirement: '6 months hitting goals' },
    { emoji: '👑', name: 'Financial Freedom Seeker', requirement: '1 year + full curriculum' },
  ];

  return (
    <section
      data-testid="levels-section"
      className="bg-[#1B4332] section-padding relative overflow-hidden"
    >
      {/* Abstract curves background */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" viewBox="0 0 1200 800" preserveAspectRatio="none">
          <path
            d="M0,400 Q300,200 600,400 T1200,400 L1200,800 L0,800 Z"
            fill="rgba(149,184,162,0.3)"
          />
          <path
            d="M0,500 Q300,300 600,500 T1200,500 L1200,800 L0,800 Z"
            fill="rgba(212,175,55,0.2)"
          />
        </svg>
      </div>

      <div className="container-custom relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p
            data-testid="levels-section-label"
            className="font-body text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase text-[#95B8A2] mb-4"
          >
            Your Financial Journey
          </p>
          <h2
            data-testid="levels-section-headline"
            className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#FAFAF7] leading-tight mb-4"
          >
            Level Up Your Finances.
            <br />
            <span className="italic">For Real.</span>
          </h2>
          <p className="font-body text-lg text-[#95B8A2] max-w-2xl mx-auto">
            Every level requires real financial achievements — not just app usage. Progress that actually means something.
          </p>
        </div>

        {/* Level Cards Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6 max-w-5xl mx-auto">
          {levels.map((level, index) => (
            <div
              key={level.name}
              data-testid={`level-card-${index}`}
              className="bg-[#FAFAF7] rounded-2xl p-5 text-center transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-[#D4AF37]/20 cursor-pointer group animate-fade-in-up"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              {/* Emoji */}
              <div className="text-4xl mb-3 transform transition-transform group-hover:scale-110">
                {level.emoji}
              </div>
              
              {/* Level Name */}
              <h4 className="font-heading text-sm lg:text-base font-bold text-[#1B4332] mb-2 leading-tight">
                {level.name}
              </h4>
              
              {/* Requirement */}
              <p className="font-body text-xs text-[#2D2D2D]/60 leading-relaxed">
                {level.requirement}
              </p>

              {/* Hover border effect */}
              <div className="absolute inset-0 rounded-2xl border-2 border-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LevelsSection;
